import { motion, useAnimationControls } from 'motion/react';
import { makeClassName } from '@siteless/util';
import { ReactNode, useEffect } from 'react';

export let PopWrapper = ({
  children,
  className,
  scaleTo = 1.15,
  disabled,
  zIndex,
  onClick,
  forcePop,
}: {
  className?: string;
  scaleTo?: number;
  children: ReactNode;
  disabled?: boolean;
  zIndex?: number;
  onClick?: () => void;
  forcePop?: boolean | number;
}) => {
  let forcePopScale =
    typeof forcePop === 'number' ? forcePop : forcePop ? scaleTo : 1;
  let controls = useAnimationControls();

  useEffect(() => {
    controls.start({
      scale: forcePopScale,
      zIndex,
      transition: { type: 'spring', stiffness: 210, damping: 20 },
    });
  }, [forcePopScale, zIndex]);

  return (
    <motion.div
      animate={controls}
      style={{ zIndex }}
      onTouchStart={() => {
        if (disabled || forcePop) return;
        controls.start({
          scale: scaleTo,
          transition: { type: 'spring', stiffness: 210, damping: 20 },
        });
      }}
      onTouchEnd={() => {
        if (disabled || forcePop) return;
        controls.start({
          scale: 1,
          transition: {
            type: 'spring',
            stiffness: 210,
            damping: 20,
            delay: 0.08,
          },
        });
      }}
      onMouseDown={() => {
        if (disabled || forcePop) return;
        controls.start({
          scale: scaleTo,
          transition: { type: 'spring', stiffness: 210, damping: 20 },
        });
      }}
      onMouseUp={() => {
        if (disabled || forcePop) return;
        controls.start({
          scale: 1,
          transition: {
            type: 'spring',
            stiffness: 210,
            damping: 20,
            delay: 0.08,
          },
        });
      }}
      onClick={disabled ? undefined : onClick}
      className={makeClassName(className, disabled ? '' : 'cursor-pointer select-none')}
    >
      {children}
    </motion.div>
  );
};
